export default {
  zh: {
    // 首屏内容
    hero: {
      title: "破解<br />“选云难、用云贵”困局",
      titleHighlight: "驱动云效跃迁",
      description:
        "云成本高昂，多云管理复杂？Cycor一站式解决方案，覆盖从采购到优化<br />的全生命周期，让您的云支出更透明、资源效率更高。",
      descriptionMobile:
        "云成本高昂，多云管理复杂？<br />Cycor一站式解决方案，<br />覆盖从采购到优化的全生命周期，<br />让您的云支出更透明、资源效率更高。",
      ctaButton: "立即咨询",
    },
    // 解决方案双引擎
    solutionsSection: {
      title: "Cycor双引擎方案：从“选好云”到“用好云”",
      cloudPurchasing: {
        title: "一站式云采购解决方案",
        subtitle: "助力企业“选好云”",
        description:
          "汇聚主流云厂商资源，直采更优惠；合同灵活、技术专业、支持 7×24 服务，并提供降本增效方案，让企业采购云更省心、更高效。",
        features: {
          vendors: {
            title: "覆盖主流厂商",
            subtitle: "选择更自由",
            description:
              "全面代理AWS、阿里云、GCP、腾讯云、华为云、Azure、Linode 等国内外所有主流云厂商。",
          },
          pricing: {
            title: "尊享更优价格",
            subtitle: "成本更可控",
            description:
              "我们与国内外主流云厂商保持长期深度合作，并获得其强有力的优惠政策支持。",
          },
          service: {
            title: "获得专业服务",
            subtitle: "过程更安心",
            description:
              "团队长期深耕云计算领域，在大数据及架构优化方面经验丰富，提供7*24小时专业技术支持服务。",
          },
        },
      },
      devfinops: {
        title: "DevFinOps多云降本解决方案",
        subtitle: "助力企业“用好云”",
        description:
          "基于FinOps创新的成本管理理念与过往大量的多云应用实践沉淀而来，以一站式云成本数据分析功能为依托，可为企业提供从0到1的陪跑式云成本优化服务，助力企业在用云全生命周期中，高效优化云资源成本，实现财务透明化和效益最大化。",
        stats: {
          amount: {
            data: "11",
            unit: "亿",
            description: "累计云上管理金额",
          },
          optimization: {
            data: "31.5",
            unit: "%",
            description: "平均云成本优化率",
          },
        },
      },
    },
    // 数据分析功能
    analyticsSection: {
      title: "一站式云成本数据分析：从“成本可视”到“智能优化”",
      dataCollection: {
        title: "自动化数据采集",
        subtitle: "多云账单可视化分析",
        description:
          "以自研云成本数据分析工具为依托，不仅可以自动收集企业在全球各大云平台上的资源消耗情况，包括但不限于利用率、使用量等多维度数据指标；同时，还可以通过可视化的图表与定制化的报告，帮助企业一目了然地洞察成本波动，为企业最大限度优化资源配置，提供数据决策路径。",
        features: {
          unified: {
            title: "统一视图 跨云管理",
            description:
              "支持AWS、阿里云、GCP、腾讯云、OCI、Azure 等全球主流云厂商。",
          },
          customizable: {
            title: "自由定制 深度洞察",
            description:
              "可以根据自身的业务需求，自定义分析维度和图表样式，满足多元数据分析与决策需求。",
          },
          drilldown: {
            title: "层层下钻 杜绝浪费",
            description:
              "支持多达四层的账单下钻分析，帮助您追踪每一项费用的根源，深入洞察成本浪费。",
          },
        },
      },
      systemManagement: {
        title: "智能化系统管理",
        subtitle: "精准识别可优化资源",
        description:
          "在智能算法的加持下，可实时追踪企业在全球各地的云资源使用情况，把原本割裂的成本、使用量、利用率联系在一起，帮助企业快速识别成本异常与浪费点，如：未充分利用的资源、高峰时段的额外成本等；同时，还可以根据企业实际业务需求进行云资源的成本预测和预算设定，避免不必要的资金支出与资源浪费。",
        features: {
          identification: {
            title: "一键识别资源浪费",
            description:
              "自动识别闲置资源、未被充分利用的资源，以及付费方式不合理的资源。",
          },
          optimization: {
            title: "一键生成优化建议",
            description:
              "生成个性化优化建议，帮助用户调整资源配置，提高服务装箱率，降低云IT成本支出。",
          },
        },
      },
    },
  },
  en: {
    // Hero section
    hero: {
      title:
        'Breaking the Dilemma of "Difficult Cloud Selection, Expensive Cloud Usage"',
      titleHighlight: "Driving Cloud Efficiency Transformation",
      description:
        "High cloud costs? Cycor's one-stop solution covers<br />the full lifecycle, boosting transparency and efficiency.",
      descriptionMobile:
        "High cloud costs and complex multi-cloud management? Cycor covers the full lifecycle,boosting transparency and efficiency.",
      ctaButton: "Contact Now",
    },
    // Solutions section
    solutionsSection: {
      title:
        'Cycor Dual-Engine Solutions: <br />From "Choosing the Right Cloud" to "Using Cloud Well"',
      cloudPurchasing: {
        title: "One-Stop Cloud Procurement Solution",
        subtitle: 'Helping Enterprises "Choose the Right Cloud"',
        description:
          "Direct access to top cloud vendors with flexible contracts, expert 24/7 support, and cost-saving solutions for easier procurement.",
        features: {
          vendors: {
            title: "Covering Mainstream Vendors",
            subtitle: "More Freedom of Choice",
            description:
              "Comprehensive agency for AWS, Alibaba Cloud, GCP, Tencent Cloud, Huawei Cloud, Azure, Linode and all other mainstream cloud vendors worldwide.",
          },
          pricing: {
            title: "Exclusive Better Pricing",
            subtitle: "More Controllable Costs",
            description:
              "We maintain long-term deep cooperation with mainstream cloud vendors worldwide and receive strong preferential policy support.",
          },
          service: {
            title: "Professional Service",
            subtitle: "More Peace of Mind",
            description:
              "Experienced in cloud computing and architecture optimization, providing 24/7 professional support.",
          },
        },
      },
      devfinops: {
        title: "DevFinOps Multi-Cloud Cost Reduction Solution",
        subtitle: 'Helping Enterprises "Use Cloud Well"',
        description:
          "Leveraging FinOps and multi-cloud experience, it offers end-to-end cloud cost optimization, maximizing transparency and resource efficiency.",
        stats: {
          amount: {
            data: "1.1",
            unit: "Billion",
            description: "Cumulative Cloud Management Amount",
          },
          optimization: {
            data: "31.5",
            unit: "%",
            description: "Average Cloud Cost Optimization Rate",
          },
        },
      },
    },
    // Analytics section
    analyticsSection: {
      title: `One-Stop Cloud Cost Data Analysis:<br /> From "Cost Visibility" to "Intelligent Optimization"`,
      dataCollection: {
        title: "Automated Data Collection",
        subtitle: "Multi-Cloud Bill Visualization Analysis",
        description:
          "Using proprietary cloud cost tools, it collects multi-dimensional resource data and visualizes cost trends, helping enterprises optimize resource allocation efficiently.",
        features: {
          unified: {
            title: "Unified View Cross-Cloud Management",
            description:
              "Supports AWS, Alibaba Cloud, GCP, Tencent Cloud, OCI, Azure and other global mainstream cloud vendors.",
          },
          customizable: {
            title: "Customizable Deep Insights",
            description:
              "Customizable charts and analysis to meet diverse business and decision-making needs.",
          },
          drilldown: {
            title: "Layer-by-Layer Drill-Down to Eliminate Waste",
            description:
              "Supports four-layer bill drill-down to track expenses and uncover cost waste",
          },
        },
      },

      systemManagement: {
        title: "Intelligent System Management",
        subtitle: "Precisely Identify Optimizable Resources",
        description:
          "Uses intelligent algorithms to track global cloud usage in real time, linking costs, usage, and utilization to spot anomalies and waste, and enabling cost forecasting and budget planning.",
        features: {
          identification: {
            title: "One-Click Resource Waste Identification",
            description:
              "Automatically identify idle resources, underutilized resources, and resources with unreasonable payment methods.",
          },
          optimization: {
            title: "One-Click Optimization Recommendation Generation",
            description:
              "Provides personalized optimization suggestions to adjust resources, improve utilization, and cut cloud IT costs.",
          },
        },
      },
    },
  },
  ja: {
    // ヒーローセクション
    hero: {
      title: "「クラウド選択困難、利用高額」のジレンマを解決",
      titleHighlight: "クラウド効率の変革を推進",
      description:
        "クラウドコストが高く、マルチクラウド管理が複雑？Cycorのワンストップソリューションは<br />調達から最適化まで全ライフサイクルをカバーし、クラウド支出をより透明に、リソース効率をより高くします。",
      descriptionMobile:
        "クラウドコスト高く、マルチクラウド管理が複雑？Cycorのワンストップソリューションで調達から最適化まで全ライフサイクルをカバーし、<br />支出を透明化、リソース効率を最大化。",
      ctaButton: "今すぐお問い合わせ",
    },
    // ソリューションセクション
    solutionsSection: {
      title:
        "Cycorデュアルエンジンソリューション：<br />「適切なクラウド選択」から「クラウドの上手な活用」まで",
      cloudPurchasing: {
        title: "ワンストップクラウド調達ソリューション",
        subtitle: "企業の「適切なクラウド選択」をサポート",
        description:
          "主流クラウドベンダーのリソースを集約し、直接調達でより優遇；柔軟な契約、専門技術、24時間対応、コスト削減ソリューションを提供し、企業のクラウド調達をより安心で効率的にします。",
        features: {
          vendors: {
            title: "主流ベンダーをカバー",
            subtitle: "より自由な選択",
            description:
              "AWS、Alibaba Cloud、GCP、Tencent Cloud、Huawei Cloud、Azure、Linodeなど、国内外のすべての主流クラウドベンダーを包括的に代理。",
          },
          pricing: {
            title: "優待価格の享受",
            subtitle: "よりコントロール可能なコスト",
            description:
              "国内外の主流クラウドベンダーと長期的な深い協力関係を維持し、強力な優待価格政策サポートを獲得。",
          },
          service: {
            title: "プロフェッショナルサービスの獲得",
            subtitle: "より安心なプロセス",
            description:
              "チームは長期間クラウドコンピューティング分野に従事し、ビッグデータとアーキテクチャ最適化において豊富な経験を持ち、7*24時間の専門技術サポートサービスを提供。",
          },
        },
      },
      devfinops: {
        title: "DevFinOpsマルチクラウドコスト削減ソリューション",
        subtitle: "企業の「クラウドの上手な活用」をサポート",
        description:
          "FinOpsのコスト管理理念と豊富なマルチクラウド実践に基づき、ワンストップクラウドコスト分析で企業を伴走し、全ライフサイクルでリソースコストを効率化、財務透明化と効果最大化を支援。",
        stats: {
          amount: {
            data: "226",
            unit: "億円",
            description: "累計クラウド管理金額",
          },
          optimization: {
            data: "31.5",
            unit: "%",
            description: "平均クラウドコスト最適化率",
          },
        },
      },
    },
    // 分析セクション
    analyticsSection: {
      title:
        "ワンストップクラウドコストデータ分析：<br />「コスト可視化」から「インテリジェント最適化」まで",
      dataCollection: {
        title: "自動化データ収集",
        subtitle: "マルチクラウド請求書可視化分析",
        description:
          "自社開発のクラウドコスト分析ツールで、主要クラウドのリソース消費を自動収集し、利用率や使用量などの指標を可視化。カスタマイズレポートでコスト変動を把握し、最適なリソース配置をサポート。",
        features: {
          unified: {
            title: "統一ビュー クロスクラウド管理",
            description:
              "AWS、Alibaba Cloud、GCP、Tencent Cloud、OCI、Azureなど世界の主流クラウドベンダーをサポート。",
          },
          customizable: {
            title: "自由カスタマイズ 深い洞察",
            description:
              "自身のビジネスニーズに応じて、分析次元とチャートスタイルをカスタマイズでき、多元的なデータ分析と意思決定ニーズを満たします。",
          },
          drilldown: {
            title: "階層ドリルダウン 無駄を根絶",
            description:
              "最大4層の請求書ドリルダウン分析をサポートし、すべての費用の根源を追跡し、コスト無駄を深く洞察するのを支援します。",
          },
        },
      },
      systemManagement: {
        title: "インテリジェントシステム管理",
        subtitle: "最適化可能リソースの精密識別",
        description:
          "インテリジェントアルゴリズムで世界中のクラウドリソース使用をリアルタイム追跡。コスト、使用量、利用率を統合し、異常や無駄を即時検出。さらに予測と予算設定で不必要な支出とリソース浪費を防止。",
        features: {
          identification: {
            title: "ワンクリック リソース無駄識別",
            description:
              "アイドルリソース、十分に利用されていないリソース、および支払い方法が不合理なリソースを自動識別。",
          },
          optimization: {
            title: "ワンクリック 最適化提案生成",
            description:
              "パーソナライズされた最適化提案を生成し、ユーザーがリソース設定を調整し、サービスパッキング率を向上させ、クラウドITコスト支出を削減するのを支援。",
          },
        },
      },
    },
  },
};
